import React from "react";

const DotsHeaderImgM = () => (
  <svg width="260" height="528" viewBox="0 0 260 528" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{mixBlendMode: "difference"}}>
<path className="st0" d="M525.4,449.4c1.8,1.3,2.3,3.8,1,5.6l0,0c-1.3,1.8-3.8,2.3-5.6,1s-2.3-3.8-1-5.6l0,0
  C521.1,448.6,523.6,448.1,525.4,449.4z" fill="#FFFFFF" />
<path className="st0" d="M542.2,421.3c-2-1-2.8-3.4-1.8-5.4l0,0c1-2,3.4-2.8,5.4-1.8s2.8,3.4,1.8,5.4l0,0
  C546.5,421.5,544.1,422.3,542.2,421.3z" fill="#FFFFFF" />
<path className="st0" d="M558.2,383.9c-2.1-0.7-3.2-3-2.5-5.1l0,0c0.7-2.1,3-3.2,5.1-2.5s3.2,3,2.5,5.1l0,0
  C562.6,383.4,560.3,384.6,558.2,383.9z" fill="#FFFFFF" />
<path className="st0" d="M568.7,344.5c-2.2-0.4-3.6-2.5-3.2-4.6l0,0c0.4-2.2,2.5-3.6,4.6-3.2c2.2,0.4,3.6,2.5,3.2,4.6l0,0
  C573,343.5,570.9,344.9,568.7,344.5z" fill="#FFFFFF" />
<path className="st0" d="M573.5,304.1c-2.2-0.1-3.9-1.9-3.9-4.1l0,0c0.1-2.2,1.9-3.9,4.1-3.9c2.2,0.1,3.9,1.9,3.9,4.1l0,0
  C577.6,302.4,575.7,304.2,573.5,304.1z" fill="#FFFFFF" />
<path className="st0" d="M572.6,263.4c-2.2,0.2-4.2-1.4-4.4-3.6l0,0c-0.2-2.2,1.4-4.2,3.6-4.4c2.2-0.2,4.2,1.4,4.4,3.6l0,0
  C576.4,261.2,574.8,263.2,572.6,263.4z" fill="#FFFFFF" />
<path className="st0" d="M566.1,223.2c-2.1,0.5-4.3-0.8-4.8-2.9l0,0c-0.5-2.1,0.8-4.3,2.9-4.8c2.1-0.5,4.3,0.8,4.8,2.9l0,0
  C569.5,220.5,568.2,222.7,566.1,223.2z" fill="#FFFFFF" />
<path className="st0" d="M554,184.3c-2,0.8-4.4-0.2-5.2-2.2l0,0c-0.8-2,0.2-4.4,2.2-5.2s4.4,0.2,5.2,2.2l0,0
  C557.1,181.1,556.1,183.5,554,184.3z" fill="#FFFFFF" />
<path className="st0" d="M536.7,147.5c-1.9,1.1-4.4,0.5-5.5-1.5l0,0c-1.1-1.9-0.5-4.4,1.5-5.5c1.9-1.1,4.4-0.5,5.5,1.5l0,0
  C539.3,143.9,538.6,146.4,536.7,147.5z" fill="#FFFFFF" />
<path className="st0" d="M514.3,113.5c-1.7,1.4-4.2,1.1-5.6-0.7l0,0c-1.4-1.7-1.1-4.2,0.7-5.6c1.7-1.4,4.2-1.1,5.6,0.7l0,0
  C516.3,109.6,516,112.1,514.3,113.5z" fill="#FFFFFF" />
<path className="st0" d="M487.2,83c-1.5,1.6-4,1.7-5.7,0.2l0,0c-1.6-1.5-1.7-4-0.2-5.7c1.5-1.6,4-1.7,5.7-0.2l0,0
  C488.7,78.9,488.7,81.4,487.2,83z" fill="#FFFFFF" />
<path className="st0" d="M456,56.9c-1.3,1.8-3.8,2.3-5.6,1l0,0c-1.8-1.3-2.3-3.8-1-5.6s3.8-2.3,5.6-1l0,0
  C456.8,52.6,457.3,55.1,456,56.9z" fill="#FFFFFF" />
<path className="st0" d="M421.3,35.5c-1,2-3.4,2.8-5.4,1.8l0,0c-2-1-2.8-3.4-1.8-5.4s3.4-2.8,5.4-1.8l0,0
  C421.5,31.1,422.3,33.5,421.3,35.5z" fill="#FFFFFF" />
<path className="st0" d="M383.9,19.4c-0.7,2.1-3,3.2-5.1,2.5l0,0c-2.1-0.7-3.2-3-2.5-5.1s3-3.2,5.1-2.5l0,0
  C383.5,15.1,384.6,17.3,383.9,19.4z" fill="#FFFFFF" />
<path className="st0" d="M344.6,8.9c-0.4,2.2-2.5,3.6-4.6,3.2l0,0c-2.2-0.4-3.6-2.5-3.2-4.6c0.4-2.2,2.5-3.6,4.6-3.2l0,0
  C343.5,4.7,345,6.8,344.6,8.9z" fill="#FFFFFF" />
<path className="st0" d="M304.1,4.1C304,6.3,302.2,8,300,8l0,0c-2.2-0.1-3.9-1.9-3.9-4.1c0.1-2.2,1.9-3.9,4.1-3.9l0,0
  C302.5,0.1,304.2,1.9,304.1,4.1z" fill="#FFFFFF" />
<path className="st0" d="M263.4,5c0.2,2.2-1.4,4.2-3.6,4.4l0,0c-2.2,0.2-4.2-1.4-4.4-3.6s1.4-4.2,3.6-4.4l0,0
  C261.2,1.3,263.2,2.8,263.4,5z" fill="#FFFFFF" />
<path className="st0" d="M223.2,11.6c0.5,2.1-0.8,4.3-2.9,4.8l0,0c-2.1,0.5-4.3-0.8-4.8-2.9s0.8-4.3,2.9-4.8l0,0
  C220.5,8.1,222.7,9.4,223.2,11.6z" fill="#FFFFFF" />
<path className="st0" d="M184.3,23.6c0.8,2-0.2,4.4-2.2,5.2l0,0c-2,0.8-4.4-0.2-5.2-2.2s0.2-4.4,2.2-5.2l0,0
  C181.2,20.6,183.5,21.6,184.3,23.6z" fill="#FFFFFF" />
<path className="st0" d="M147.5,41c1.1,1.9,0.5,4.4-1.5,5.5l0,0c-1.9,1.1-4.4,0.5-5.5-1.5c-1.1-1.9-0.5-4.4,1.5-5.5l0,0
  C143.9,38.4,146.4,39.1,147.5,41z" fill="#FFFFFF" />
<path className="st0" d="M113.5,63.4c1.4,1.7,1.1,4.2-0.7,5.6l0,0c-1.7,1.4-4.2,1.1-5.6-0.7c-1.4-1.7-1.1-4.2,0.7-5.6l0,0
  C109.6,61.3,112.1,61.6,113.5,63.4z" fill="#FFFFFF" />
<path className="st0" d="M83.1,90.4c1.6,1.5,1.7,4,0.2,5.7l0,0c-1.5,1.6-4,1.7-5.7,0.2c-1.6-1.5-1.7-4-0.2-5.7l0,0
  C78.9,89,81.5,88.9,83.1,90.4z" fill="#FFFFFF" />
<path className="st0" d="M56.9,121.6c1.8,1.3,2.3,3.8,1,5.6l0,0c-1.3,1.8-3.8,2.3-5.6,1s-2.3-3.8-1-5.6l0,0
  C52.6,120.8,55.1,120.4,56.9,121.6z" fill="#FFFFFF" />
<path className="st0" d="M32,163.5c-2-1-2.8-3.4-1.8-5.4l0,0c1-2,3.4-2.8,5.4-1.8s2.8,3.4,1.8,5.4l0,0C36.3,163.7,33.9,164.5,32,163.5z"
   fill="#FFFFFF" />
<path className="st0" d="M17,201.3c-2.1-0.7-3.2-3-2.5-5.1l0,0c0.7-2.1,3-3.2,5.1-2.5s3.2,3,2.5,5.1l0,0C21.3,200.9,19.1,202,17,201.3z"
   fill="#FFFFFF" />
<path className="st0" d="M7.6,241c-2.2-0.4-3.6-2.5-3.2-4.6l0,0c0.4-2.2,2.5-3.6,4.6-3.2c2.2,0.4,3.6,2.5,3.2,4.6l0,0
  C11.8,239.9,9.8,241.4,7.6,241z" fill="#FFFFFF" />
<path className="st0" d="M3.9,281.5c-2.2-0.1-3.9-1.9-3.9-4.1l0,0c0.1-2.2,1.9-3.9,4.1-3.9c2.2,0.1,3.9,1.9,3.9,4.1l0,0
  C8,279.9,6.1,281.6,3.9,281.5z" fill="#FFFFFF" />
<path className="st0" d="M5.9,322.2c-2.2,0.2-4.2-1.4-4.4-3.6l0,0c-0.2-2.2,1.4-4.2,3.6-4.4c2.2-0.2,4.2,1.4,4.4,3.6l0,0
  C9.7,320,8.1,322,5.9,322.2z" fill="#FFFFFF" />
<path className="st0" d="M13.6,362.2c-2.1,0.5-4.3-0.8-4.8-2.9l0,0c-0.5-2.1,0.8-4.3,2.9-4.8s4.3,0.8,4.8,2.9l0,0
  C17,359.5,15.7,361.7,13.6,362.2z" fill="#FFFFFF" />
<path className="st0" d="M26.7,400.7c-2,0.8-4.4-0.2-5.2-2.2l0,0c-0.8-2,0.2-4.4,2.2-5.2s4.4,0.2,5.2,2.2l0,0
  C29.7,397.6,28.7,399.9,26.7,400.7z" fill="#FFFFFF" />
<path className="st0" d="M45,437.1c-1.9,1.1-4.4,0.5-5.5-1.5l0,0c-1.1-1.9-0.5-4.4,1.5-5.5c1.9-1.1,4.4-0.5,5.5,1.5l0,0
  C47.6,433.5,46.9,436,45,437.1z" fill="#FFFFFF" />
<path className="st0" d="M68.4,470.4c-1.7,1.4-4.2,1.1-5.6-0.7l0,0c-1.4-1.7-1.1-4.2,0.7-5.6c1.7-1.4,4.2-1.1,5.6,0.7l0,0
  C70.4,466.6,70.1,469.1,68.4,470.4z" fill="#FFFFFF" />
<path className="st0" d="M96.3,500.1c-1.5,1.6-4,1.7-5.7,0.2l0,0c-1.6-1.5-1.7-4-0.2-5.7c1.5-1.6,4-1.7,5.7-0.2l0,0
  C97.7,495.9,97.8,498.5,96.3,500.1z" fill="#FFFFFF" />
<path className="st0" d="M128.2,525.3c-1.3,1.8-3.8,2.3-5.6,1l0,0c-1.8-1.3-2.2-3.8-1-5.6c1.3-1.8,3.8-2.3,5.6-1l0,0
  C129.1,521,129.5,523.5,128.2,525.3z" fill="#FFFFFF" />
</g>
</svg>
);

export default DotsHeaderImgM;
